/* eslint-disable max-lines */
import Vue from "vue";
import BrandApi from "../../services/api/brandApi.js";
import FileSelected from "@/views/onboarding/FileSelected";

const BrandApiService = new BrandApi(),
  dict = {
    custom: {
      email: {
        required: "Please fill out",
        email: "Please enter valid email",
      },
      "lead time": {
        required: "Please fill out",
        numeric: "Please use numbers only",
      },
      mov: {
        required: "Please fill out",
        decimal: "Please use numbers only",
      },
    },
  };

export default {
  components: { FileSelected },
  provide() {
    return { parentValidator: this.$validator };
  },
  data() {
    return {
      loading: true,
      submited: false,
      categories: [],
      uploadInProgress: false,
      brand_values: [],
      profileImageSrc: "",
      model: {
        address: null,
        first_name: "",
        last_name: "",
        owner_first_name: "",
        owner_last_name: "",
        ships_from_us_or_ca: null,
        phone: "",
        is_CA: false,
        located_in_us_or_ca: null,
        have_shop: null,
        years_in_business: "",
        brand_name: "",
        instagram: "",
        instagram_followers: "",
        website_url: "",
        w9: null,
        w9_url: "",
        header_image: null,
        brand_bio_image_url: "",
        profile_image: null,
        thumbnail_image_url: "",
        email: "",
        based_in: "",
        based_in_canada: null,
        shipping_city: "",
        customer_description: "",
        categories: [],
        lead_time: "",
        minimum_quantity: "",
        moq: "",
        minimum_order_value: "",
        minimum_reorder_value: "",
        order_under_mov: "",
        ship_to_canada: null,
        bestsellers: "",
        linesheet_url: "",
        linesheet_file_name: null,
        msrp: "Yes, take 50% MSRP from consumer site.",
        wholesale_notes: "",
        initial_skus: "",
        product_photography: "",
        editorial: "",
        brand_bio: "",
        values: [],
        case_pack_quantity: "",
      },
    };
  },

  methods: {
    getBrandValues() {
      BrandApiService.getBrandValues().then(({ data }) => {
        this.brand_values = data.map((brand) => ({ ...brand, ...{ name: brand.label } }));
      });
    },
    getInfoFromCode,
    upload,
    removeFile,
    triggerInputFile,
    onInputFileChange,
    validate,
    submit,
    postToAirtable,
    insertRemoveFromArray,
    dropdownCallback,
    getProductCategories,
    toggleAll,
    checkParentCheckbox,
    handleError,
    addBrandImage,
    removeBrandImage,
    addDroppedFile,
    selectBrandValue(payload) {
      this.brand_values = this.brand_values.map((category) => (category.value === payload.value ? payload : category));
    },
    selectCategory(payload) {
      this.categories = this.categories.map((category) => (category.id === payload.id ? payload : category));
    },
    removeBrandValueChip(payload) {
      this.brand_values = this.brand_values.map((category) =>
        category.value === payload.value
          ? {
              ...payload,
              ...{ selected: false },
            }
          : category
      );
    },
    removeCategoryChip(payload) {
      this.categories = this.categories.map((category) =>
        category.id === payload.id
          ? {
              ...payload,
              ...{ selected: false },
            }
          : category
      );
    },
    async handleSubmitClick(e) {
      e.preventDefault();
      this.validate();
    },
    onAddressChanged: function (address) {
      this.model.address = address;
    },
    async uploadLineSheet(event) {
      if (!event.target.files.length) {
        return;
      }
      const docForm = new FormData();
      docForm.append("doc", event.target.files[0], event.target.files[0].name);
      try {
        const { data: line_sheet_url } = await BrandApiService.uploadDocs(
          docForm,
          this.$route.query.code && this.$route.query.code
        );
        this.model.linesheet_file_name = event.target.files[0].name;
        this.model.linesheet_file = line_sheet_url;
      } catch (error) {
        this.$bugsnagClient.notify(new Error("File Upload Error" + error));
      }
    },
    removeLineSheetFile() {
      this.$refs.linesheet_url_input.type = "text";
      this.$refs.linesheet_url_input.type = "file";
      this.model.linesheet_file_name = null;
      this.model.linesheet_file = null;
    },
  },

  beforeMount() {
    this.$validator.localize("en", dict);
    if (this.$route.query.code) {
      this.getInfoFromCode();
    } else {
      this.loading = false;
    }

    this.getBrandValues();
    this.getProductCategories();
    this.$ma.trackEvent({
      action: "Onboarding Form Pageview",
      properties: {
        email: this.model.email,
        brand_name: this.model.brand_name,
      },
    });
  },
};

function addDroppedFile(event) {
  const dataTransfer = event.dataTransfer,
    files = dataTransfer.files;
  this.model["w9"] = files[0];
}

function checkParentCheckbox(val, parentIndex) {
  if (!val) {
    this.categories[parentIndex].selected = false;
  }
}

function toggleAll(index) {
  this.$set(this.categories[index], "selected", !this.categories[index].selected);

  const selected = Boolean(this.categories[index].selected);

  this.categories[index].view_components.forEach((subcategory) => {
    Vue.set(subcategory, "selected", selected);
  });
}

function removeFile(input, modelKey) {
  input.value = "";
  this.model[modelKey] = null;
}

function triggerInputFile(ref) {
  this.$refs[ref].click();
}

// eslint-disable-next-line complexity
function onInputFileChange(event, input) {
  if (!event.target.files.length) {
    return;
  }

  const file = event.target.files[0];

  if (
    input !== "header_image" &&
    file.size > this.$utils.getByteSizeFromMegabyteSize(this.$utils.constants.CSV_UPLOAD_SIZE_LIMIT_MB)
  ) {
    this.removeFile(event.target, input);
    return this.$swal({
      title: this.$utils.constants.CSV_UPLOAD_SIZE_LIMIT_ERROR_MESSAGE,
    });
  } else if (input === "header_image") {
    if (file.size > this.$utils.getByteSizeFromMegabyteSize(this.$utils.constants.IMAGE_UPLOAD_SIZE_LIMIT_MB)) {
      this.removeFile(event.target, input);
      return this.$swal({
        title: this.$utils.constants.IMAGE_UPLOAD_SIZE_LIMIT_ERROR_MESSAGE,
      });
    }

    const reader = new FileReader(),
      image = new Image();

    reader.readAsDataURL(file);

    reader.onload = (readerEvent) => {
      image.src = readerEvent.target.result;
    };

    image.onload = () => {
      this.model[input] = null;
      this.model[input] = file;
    };
  } else {
    this.model[input] = null;
    this.model[input] = event.target.files[0];
  }
}

function insertRemoveFromArray(val, array) {
  const index = this.model[array].indexOf(val),
    start = 1;

  if (index === -1) {
    this.model[array].push(val);
  } else {
    this.model[array].splice(index, start);
  }
}

// eslint-disable-next-line no-unused-vars
function dropdownCallback(val, index = false, parentIndex = false, modelName) {
  this.model[modelName] = val.name;
}

function validate() {
  const _self = this,
    timeoutLength = 100;

  // eslint-disable-next-line complexity
  _self.$validator.validate().then(async (valid) => {
    // START validation check
    if (!valid) {
      //get first error from errorBag
      const firstErrorFieldName = this.errors.items[0].field,
        targetElement = document.querySelectorAll(`[name='${firstErrorFieldName}']`)[0].parentElement;
      _self.$utils.scrollTo(targetElement);
      return;
    }
    if (!_self.model.profile_image) {
      _self.$swal("Attention", "Please upload brand image");
      setTimeout(() => _self.$utils.scrollTo(document.getElementById("profileImage")), timeoutLength);
      return;
    }
    if (!_self.model.w9) {
      const { value, dismiss } = await _self.$swal("Attention", "Please attach w9 document");
      if (value || dismiss === "close") {
        setTimeout(function () {
          _self.$utils.scrollTo(document.getElementById("w9FileInput"));
        }, timeoutLength);
      }
      return;
    }
    _self.model.categories = this.categories.filter((item) => item.selected);
    if (!_self.model.categories.length) {
      const { value, dismiss } = await _self.$swal("Attention", "Please select at least one category you can offer.");
      (value || dismiss === "close") &&
        setTimeout(() => _self.$utils.scrollTo(document.getElementById("categories")), timeoutLength);

      return;
    }
    _self.model.values = this.brand_values.filter((item) => item.selected);
    if (!_self.model.values.length) {
      const { value, dismiss } = await _self.$swal(
        "Attention",
        "Please select at least one option that applies to your brand."
      );
      (value || dismiss === "close") &&
        setTimeout(() => _self.$utils.scrollTo(document.getElementById("brandValues")), timeoutLength);

      return;
    }
    const hasFile = this.model.linesheet_file !== null,
      hasLineSheet = this.model.linesheet_url.length !== 0;
    if (!(hasFile || hasLineSheet)) {
      const { value, dismiss } = await this.$swal("Attention", "Please attach a line sheet or provide a link");
      (value || dismiss === "close") &&
        setTimeout(() => this.$utils.scrollTo(document.getElementById("line-sheet")), 500);
      return;
    }
    // END Validation checks

    // SUCCESS
    _self.submited = true;
    _self.upload();
  });
}

async function upload() {
  const w9FormData = new FormData(),
    profileImageFormData = new FormData(),
    form = new FormData();

  if (this.$route.query.code) {
    w9FormData.append("doc", this.model.w9, "w9Doc");
    profileImageFormData.append("doc", this.model.profile_image, "profileImage");
    // lineSheetData.append("doc", this.model.linesheet_file, "lineSheetData");

    this.model.w9_url = {
      url: (await BrandApiService.uploadDocs(w9FormData, this.$route.query.code)).data,
    };
    this.model.thumbnail_image_url = {
      url: (await BrandApiService.uploadDocs(profileImageFormData, this.$route.query.code)).data,
    };

    this.submit();
  } else {
    form.append("w9", this.model.w9, "w9");
    form.append("brand_bio_image", this.model.profile_image, "brand_bio_image");

    this.submit(form);
  }
}

function submit(form) {
  if (this.$route.query.code) {
    const inboundData = {
      first_name: this.model.first_name,
      last_name: this.model.last_name,
      email: this.model.email,
      brand_name: this.model.brand_name,
      website_url: this.model.website_url,
      location: this.model.address.city,
      years_in_business: this.model.years_in_business.toString(),
      based_in: this.model.based_in === "Yes" ? "US_or_CA" : "OTHER",
      shipping_city: "shipping_city", // ???
      categories: this.categories.filter((cat) => cat.selected).map((cat) => cat.name),
      instagram: this.model.instagram,
      lead_time_to: parseInt(this.model.lead_time),
      lead_time_from: 0,
      minimum_order_value: parseInt(this.model.minimum_order_value),
      minimum_reorder_value: parseInt(this.model.minimum_reorder_value),
      initial_skus: this.model.initial_skus,
      brand_bio: this.model.brand_bio,
      ship_to_canada: this.model.ship_to_canada === "Yes",
      values: this.brand_values.filter((value) => value.selected).map((value) => value.value),
      case_pack_quantity: parseInt(this.model.case_pack_quantity),
      owner_first_name: this.model.owner_first_name,
      owner_last_name: this.model.owner_last_name,
      sell_with_other_shop: this.model.have_shop === "Yes",
      phone_number: this.model.phone,
      address: this.model.address,
      line_sheet_url: this.model.linesheet_file ? this.model.linesheet_file : this.model.line_sheet_url,
      based_in_canada: this.model.is_CA,
      located_in_usa_canada: this.model.based_in_canada === "Yes",
      product_photography: this.model.product_photography,
      instagram_follower: parseInt(this.model.instagram_followers),
      editorial_link: this.model.editorial,
      code: this.$route.query.code,
      thumbnail_image_url: this.model.thumbnail_image_url.url,
      best_sellers: this.model.bestsellers,
    };
    BrandApiService.onboardingFormSubmit(inboundData)
      .then(({ data: { brand_id: brandId } }) => {
        this.model.line_sheet_url = this.model.linesheet_file ? this.model.linesheet_file : this.model.line_sheet_url;
        this.postToAirtable({
          brand_id: brandId,
        });
      })
      .catch((error) => {
        this.handleError(error);
      });
  } else {
    const outboundData = {
      first_name: this.model.first_name,
      last_name: this.model.last_name,
      email: this.model.email,
      brand_name: this.model.brand_name,
      website_url: this.model.website_url,
      location: "location",
      years_in_business: this.model.years_in_business,
      based_in: this.model.based_in === "Yes" ? "US_or_CA" : "OTHER",
      shipping_city: this.model.shipping_city, // ???
      categories: this.categories.filter((cat) => cat.selected).map((cat) => cat.name),
      instagram: this.model.instagram,
      lead_time_to: this.model.lead_time,
      lead_time_from: 0,
      minimum_order_value: this.model.minimum_order_value,
      minimum_reorder_value: this.model.minimum_reorder_value,
      initial_skus: this.model.initial_skus,
      brand_bio: this.model.brand_bio,
      ship_to_canada: this.model.ship_to_canada === "Yes",
      values: this.brand_values.filter((value) => value.selected).map((value) => value.value),
      case_pack_quantity: this.model.case_pack_quantity,
      owner_first_name: this.model.owner_first_name,
      owner_last_name: this.model.owner_last_name,
      sell_with_other_shop: this.model.have_shop === "Yes",
      phone_number: this.model.phone,
      address: this.model.address,
      line_sheet_url: this.model.linesheet_file ? this.model.linesheet_file : this.model.line_sheet_url,
      based_in_canada: this.model.is_CA,
      editorial_link: this.model.editorial,
      located_in_usa_canada: this.model.based_in_canada === "Yes",
      instagram_follower: parseInt(this.model.instagram_followers),
      product_photography: this.model.product_photography,
      best_sellers: this.model.bestsellers,
    };
    const dataBlob = new Blob([JSON.stringify(outboundData)], {
      type: "application/json",
    });
    form.append("data", dataBlob);

    BrandApiService.outboundOnboardingFormSubmit(form)
      .then(({ data }) => {
        this.model.w9_url = {
          url: data.w9_url,
        };
        this.model.brand_bio_image_url = {
          url: data.brand_bio_image_url,
        };
        this.model.thumbnail_image_url = {
          url: data.brand_bio_image_url,
        };
        this.model.line_sheet_url = this.model.linesheet_file ? this.model.linesheet_file : this.model.line_sheet_url;
        this.postToAirtable({
          brand_id: data.brand_id,
        });
      })
      .catch((error) => {
        this.handleError(error);
      });
  }
}

function handleError(error) {
  this.submited = false;
  if (error.response) {
    this.$swal("Attention", error.response.data.error_message);
  } else {
    this.$bugsnagClient.notify(new Error("Onboarding Form API Error " + error));
  }
}

function postToAirtable({ brand_id: brandId }) {
  const request = this.model;
  request.categories = this.categories.filter((cat) => cat.selected).map((cat) => cat.name);
  request.values = this.brand_values.filter((value) => value.selected).map((value) => value.value);
  brandId && (request.brand_id = brandId);
  BrandApiService.onboardingFormSubmitAirtable(request)
    .then(() => {
      this.$swal("Success", "You have successfully completed your onboarding form!").then(() => {
        this.$ma.trackEvent({
          action: "Onboarding Form Submit",
          properties: {
            email: this.model.email,
            brand_name: this.model.brand_name,
          },
        });
        this.$router.push("/home");
      });
    })
    .catch((error) => {
      this.submited = false;
      // print generic message because airtable does not return readable messages.
      this.$swal("Attention", "Something went wrong, please try again later.");
      this.$bugsnagClient.notify(new Error("Onboarding Form Airtable Error " + error));
    });
}

async function getProductCategories() {
  this.categories = (await this.$utils.getProductCategories()).reduce((total, category) => {
    if (category.container_direction === "GRID") {
      return [
        ...total,
        ...category.children_containers.map((container) => {
          return {
            ...container,
            name: `${category.name} (${container.name})`,
          };
        }),
      ];
    }

    return [...total, category];
  }, []);
}

function getInfoFromCode() {
  // get field values from previous signup form
  BrandApiService.getInfoFromCode(this.$route.query.code)
    .then(({ data }) => {

      if (data?.onboard_complete) {
        this.$router.replace("/404?target=onboarding");
        return;
      }

      this.model.brand_name = data.brand_name;
      this.model.email = data.email;
      this.model.website_url = data.website_url;
      this.model.shipping_city = data.shipping_city;
      this.model.first_name = data.first_name;
      this.model.last_name = data.last_name;
      this.model.years_in_business = data.years_in_business;
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$bugsnagClient.notify(new Error(error));
      }
    })
    .finally(() => {
      this.loading = false;
    });
}

function addBrandImage(imgData) {
  const { src, file } = imgData;
  this.model.profile_image = file;
  this.profileImageSrc = src;
}

function removeBrandImage() {
  this.model.profile_image = null;
  this.profileImageSrc = null;
}
